module.exports = __webpack_public_path__ + "static/media/receipt-disscount.e95e183b.svg";